import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { from, Observable } from "rxjs";

import { GoogleLoginComponent } from "./google-login/google-login.component";
import { SocialLoginService } from "./social.login.service";

@Component({
	selector: "obg-social-login-container",
	templateUrl: "./social-login.container.html",
	styleUrls: ["./social-login.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [CommonModule, CoreContentModule, GoogleLoginComponent],
	providers: [SocialLoginService],
})
export class SocialLoginContainer implements OnInit {
	isGoogleLoginEnabled$: Observable<boolean> | undefined;

	@HostBinding("class.obg-m-social-login-container") hostCssClass = true;
	constructor(private socialLoginService: SocialLoginService) {}

	ngOnInit(): void {
		this.isGoogleLoginEnabled$ = from(this.socialLoginService.getIsGoogleLoginEnabled());
	}
}
